import { tv } from 'tailwind-variants';

const button = tv({
  base: 'flex items-center justify-center cursor-pointer outline-none border-none',
  variants: {
    type: {
      button: {
        base: ''
      }
    },
    buttonType: {
      brand:
        'text-action-inverse bg-button-default-brand hover:bg-button-active-brand',
      cta: 'text-action-inverse bg-button-default-cta hover:bg-button-active-cta',
      basic: 'text-action bg-button-default-basic hover:bg-button-active-basic'
    },
    radius: {
      xs: 'rounded-xs',
      sm: 'rounded-sm',
      md: 'rounded-md',
      lg: 'rounded-lg',
      xl: 'rounded-xl',
      '2xl': 'rounded-2xl',
      full: 'rounded-full'
    },
    space: {
      xs: 'p-button-xs',
      sm: 'p-button-sm',
      md: 'p-button-md',
      lg: 'p-button-lg',
      xl: 'p-button-xl',
      '2xl': 'p-button-2xl',
      '3xl': 'p-button-3xl'
    },
    size: {
      s: 'p-button-sm',
      m: 'p-button-lg',
      l: 'p-button-2xl',
      xl: 'p-button-2xl'
    },
    disabled: {
      true: ''
    },
    iconColorAttr: {
      fill: '',
      stroke: ''
    }
  },
  defaultVariants: {
    buttonType: 'brand',
    disabled: false,
    space: '2xl',
    radius: 'full'
  },
  compoundVariants: [
    {
      buttonType: 'brand',
      iconColorAttr: 'fill',
      className: 'icon-fill-color-text-action-inverse'
    },
    {
      buttonType: 'brand',
      iconColorAttr: 'stroke',
      className: 'icon-stroke-color-text-action-inverse'
    },
    {
      buttonType: 'cta',
      iconColorAttr: 'fill',
      className: 'icon-fill-color-text-action-inverse'
    },
    {
      buttonType: 'cta',
      iconColorAttr: 'stroke',
      className: 'icon-stroke-color-text-action-inverse'
    },
    {
      buttonType: 'basic',
      iconColorAttr: 'fill',
      className: 'icon-fill-color-text-action'
    },
    {
      buttonType: 'basic',
      iconColorAttr: 'stroke',
      className: 'icon-stroke-color-text-action'
    },
    {
      buttonType: 'brand',
      iconColorAttr: 'fill',
      disabled: true,
      className:
        '!icon-fill-color-text-inactive bg-button-inactive-brand hover:bg-button-inactive-brand focus:shadow-none cursor-default'
    },
    {
      buttonType: 'cta',
      iconColorAttr: 'fill',
      disabled: true,
      className:
        '!icon-fill-color-text-inactive bg-button-inactive-cta hover:bg-button-inactive-cta focus:shadow-none cursor-default'
    },
    {
      buttonType: 'basic',
      iconColorAttr: 'fill',
      disabled: true,
      className:
        '!icon-fill-color-text-inactive bg-button-inactive-basic hover:bg-button-inactive-basic focus:shadow-none cursor-default'
    },
    {
      buttonType: 'brand',
      iconColorAttr: 'stroke',
      disabled: true,
      className:
        '!icon-stroke-color-text-inactive bg-button-inactive-brand hover:bg-button-inactive-brand focus:shadow-none cursor-default'
    },
    {
      buttonType: 'cta',
      iconColorAttr: 'stroke',
      disabled: true,
      className:
        '!icon-stroke-color-text-inactive bg-button-inactive-cta hover:bg-button-inactive-cta focus:shadow-none cursor-default'
    },
    {
      buttonType: 'basic',
      iconColorAttr: 'stroke',
      disabled: true,
      className:
        '!icon-stroke-color-text-inactive bg-button-inactive-basic hover:bg-button-inactive-basic focus:shadow-none cursor-default'
    }
  ]
});

const spinner = tv({
  base: 'opacity-90 [&>path:nth-child(odd)]:opacity-50',
  defaultVariants: {}
});

export { button, spinner };
